import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Compass, HelpCircle, Utensils, Radio } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const HIDDEN_ON = ["/story/", "/admin"];

/** Phone-only bottom app bar (hidden ≥768px, where the top header keeps the links). */
export default function BottomNav() {
  const { t } = useLang();
  const { pathname } = useLocation();
  if (HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;
  const items = [
    { to: "/", label: t("nav_explore"), icon: Compass, testid: "bottom-nav-explore", match: (p) => p === "/" },
    { to: "/quiz", label: t("quiz"), icon: HelpCircle, testid: "bottom-nav-quiz", match: (p) => p.startsWith("/quiz") },
    { to: "/ricettario", label: t("nav_recipes"), icon: Utensils, testid: "bottom-nav-recipes", match: (p) => /^\/(ricettario|cookbook|recipe)/.test(p) },
    { to: "/radio", label: t("radio"), icon: Radio, testid: "bottom-nav-radio", match: (p) => p.startsWith("/radio") },
  ];
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-stoneLine/70 bg-sand/95 backdrop-blur-xl print:hidden pb-[env(safe-area-inset-bottom)]" data-testid="bottom-nav" aria-label="Main">
      <ul className="grid grid-cols-4">
        {items.map(({ to, label, icon: Icon, testid, match }) => {
          const active = match(pathname);
          return (
            <li key={to}>
              <Link to={to} data-testid={testid} aria-current={active ? "page" : undefined}
                className={`flex flex-col items-center gap-0.5 py-2 text-[10px] font-semibold tracking-wide transition-colors ${active ? "text-ochre" : "text-ink/60 hover:text-ink"}`}>
                <span className={`w-11 h-7 rounded-full flex items-center justify-center transition-colors ${active ? "bg-ochre/15" : ""}`}><Icon className="w-5 h-5" /></span>
                {label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
